import {
  Field,
  Text,
  useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { ComponentProps } from "@repo/sitecore-lib/component-props";
import {
  TYPOGRAPHY_DISPLAY1,
  TYPOGRAPHY_BODY3_SENTENCE,
} from "@/typography-constants";
import styles from "./editorial-paragraph.module.css";

export type EditorialParagraphProps = ComponentProps & {
  fields: {
    heading?: Field<string>;
    text?: Field<string>;
  };
  textColour?: Field<string>;
  classnames?: string[];
  imageFullWidth: boolean;
};

const EditorialParagraph = ({
  classnames,
  imageFullWidth,
  ...props
}: EditorialParagraphProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  if (
    !isEditing &&
    !props.fields?.heading?.value &&
    !props.fields?.text?.value
  ) {
    return <></>;
  }
  const textColour = props.textColour?.value || "";
  const stylesArr = classnames || props.params.styles?.split(" ");
  const isParagraphComponent =
    props.rendering.componentName.match(/paragraph/i);

  const getComponentClass = (classArray: string[] | undefined) => {
    if (!classArray) return "";
    return classArray.map((className) => styles[className]);
  };

  return (
    <div
      className={clsx(
        ...getComponentClass(stylesArr),
        imageFullWidth && styles.containerPadding,
        isParagraphComponent ? styles.paragraphContainer : styles.gridContainer,
      )}
    >
      <div className={styles.textContainer}>
        <Text
          tag="h2"
          field={props.fields.heading}
          className={clsx(TYPOGRAPHY_DISPLAY1, styles.headline)}
          style={{ color: textColour ?? "inherit" }}
        />
        <Text
          tag="p"
          field={props.fields.text}
          className={clsx(TYPOGRAPHY_BODY3_SENTENCE, styles.description)}
          style={{ color: textColour ?? "inherit" }}
        />
      </div>
    </div>
  );
};

export default EditorialParagraph;
